import classNames from 'classnames';
import { quote, quoteMark } from './Quote.css';
import type { PostQuoteProps } from './Quote.types';

export const PostQuote = ({ element, children, className, ...props }: PostQuoteProps) => {
  return (
    <div className={classNames(className, quote)} {...props}>
      <div className={quoteMark}>❝</div>
      {children}
    </div>
  );
};
